import * as z from 'zod';

import { LosId } from '../../BrandedIds';
import { zodBrandedString } from '../../utils';
import { InsuranceFields } from './sharedFields/InsuranceFields';

export const CreateEscrowSettingsRow = z.object({
  loanId: zodBrandedString<LosId>(),
  ...InsuranceFields.shape,
});

export type CreateEscrowSettingsRow = z.infer<typeof CreateEscrowSettingsRow>;

export const CREATE_ESCROW_SETTINGS_ROW_REQUIRED_FIELDS = Object.keys(CreateEscrowSettingsRow.shape).filter(
  (key) => !CreateEscrowSettingsRow.shape[key as keyof typeof CreateEscrowSettingsRow.shape].isOptional(),
) as (keyof CreateEscrowSettingsRow)[];
